const baseURL = 'https://tecnologia.encatalogo.com';

export default baseURL;
